import { network } from "../config";
import {
  FilteredPublicationsResponse,
  Publication,
  PublicationFileAccessResponse,
  PublicationFilesResponse,
  PublicationFilters,
  PublicationModerationUpdate,
  PublicationUpdateResponse,
} from "../types/Publications";
import url from "../utils/formApiUrl";
import customKy from "./kyExtend";

const { publications } = network;

const baseURL = process.env.REACT_APP_HTTP_CONNECTION_STRING + "publications/";

const getAuthHeader = (token: string) => {
  return { Authorization: `Bearer ${token}` };
};

export default class PublicationsApi {
  static async getPublicationById(
    token: string,
    publicationId: string,
  ): Promise<Publication | null> {
    return await customKy
      .get(url(baseURL, publications.getPublicationById, { id: publicationId }), {
        headers: getAuthHeader(token),
      })
      .then((response) => response.json());
  }

  static async getFilteredPublications(
    token: string,
    filters: PublicationFilters,
  ): Promise<FilteredPublicationsResponse> {
    return await customKy
      .post(
        url(baseURL, publications.getFilteredPublications, {
          page: filters.page,
          limit: filters.limit,
        }),
        {
          headers: getAuthHeader(token),
          json: { filters },
          timeout: 30000,
        },
      )
      .then((response) => response.json());
  }

  static async getPublicationFiles(
    token: string,
    publicationId: string,
  ): Promise<PublicationFilesResponse> {
    return await customKy
      .get(url(baseURL, publications.getFiles, { id: publicationId }), {
        headers: getAuthHeader(token),
      })
      .then((response) => response.json());
  }

  static async getPublicationFileAccess(
    token: string,
    publicationId: string,
    fileId: string,
  ): Promise<PublicationFileAccessResponse> {
    return await customKy
      .get(
        url(baseURL, publications.getFileAccess, {
          id: publicationId,
          fileId,
        }),
        { headers: getAuthHeader(token) },
      )
      .then((response) => response.json());
  }

  static async updatePublication(
    token: string,
    publicationId: string,
    updateData: PublicationModerationUpdate,
  ): Promise<PublicationUpdateResponse> {
    return await customKy
      .patch(url(baseURL, publications.update, { id: publicationId }), {
        headers: getAuthHeader(token),
        json: { updateData },
      })
      .then((response) => response.json());
  }
}
